class UltraRelated {
  constructor(sectionElement) {
    this.container = sectionElement;
    this.sectionId = this.container.dataset.sectionInstance;
    this.modal = this.container.querySelector('.ultra-rel__modal');
    this.slider = this.container.querySelector('.ultra-rel__slider');
    
    this.initSlider(); 
    this.initCards();
    this.initModal();
  }

  /* --- 1. MAIN SLIDER (Native Scroll) --- */
  initSlider() {
    const prev = this.container.querySelector('.prev-btn');
    const next = this.container.querySelector('.next-btn');
    
    if(prev && next) {
      prev.addEventListener('click', () => this.slider.scrollBy({ left: -300, behavior: 'smooth' }));
      next.addEventListener('click', () => this.slider.scrollBy({ left: 300, behavior: 'smooth' }));
    }
  }

  /* --- 2. CARD INTERACTIONS --- */
  initCards() {
    // Mini Gallery Nav (Native)
    this.container.querySelectorAll('.ultra-rel__img-nav').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const card = btn.closest('.ultra-rel__card');
        const track = card.querySelector('.ultra-rel__gallery-track');
        const dir = btn.classList.contains('left') ? -1 : 1;
        const w = track.clientWidth;
        track.scrollBy({ left: w * dir, behavior: 'smooth' });
      });
    });

    // Quick View Trigger
    this.container.querySelectorAll('[data-qv-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if(trigger.hasAttribute('disabled')) return;
        if(e.target.classList.contains('ultra-rel__img-nav')) return;
        const id = trigger.dataset.id;
        this.openModal(id);
      });
    });
  }

  /* --- 3. MODAL LOGIC (Native Scroll) --- */
  initModal() {
    if (!this.modal) return;

    this.modal.querySelectorAll('.qv-trigger-close').forEach(el => {
      el.addEventListener('click', () => this.closeModal());
    });

    // Modal Slider Arrows
    this.modal.querySelectorAll('.ultra-rel__arrow').forEach(arrow => {
      arrow.addEventListener('click', () => {
        const track = this.modal.querySelector('.ultra-rel__track');
        const dir = parseInt(arrow.dataset.dir); // -1 or 1
        const w = track.clientWidth;
        track.scrollBy({ left: w * dir, behavior: 'smooth' });
      });
    });
  }

  openModal(productId) {
    const dataEl = this.container.querySelector(`#data-${productId}`);
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);

    // Populate
    this.modal.querySelector('.ultra-rel__qv-title').innerText = data.title;
    this.modal.querySelector('.ultra-rel__qv-price').innerText = data.price;
    this.modal.querySelector('.ultra-rel__qv-desc').innerText = data.desc;
    this.modal.querySelector('.ultra-rel__variant-id').value = data.id;
    
    const viewDetailsLink = this.modal.querySelector('.ultra-rel__view-details');
    if (viewDetailsLink) viewDetailsLink.href = data.url;

    const stockMsg = this.modal.querySelector('.ultra-rel__qv-stock');
    if(data.is_low_stock) {
       stockMsg.innerText = `🔥 Only ${data.inventory_qty} left in stock!`;
       stockMsg.style.display = 'block';
    } else {
       stockMsg.style.display = 'none';
    }

    const btn = this.modal.querySelector('.ultra-rel__qv-add');
    const span = btn.querySelector('span');
    if (data.available) {
      btn.disabled = false;
      if(span) span.innerText = "Add to Cart";
    } else {
      btn.disabled = true;
      if(span) span.innerText = "Sold Out";
    }

    // Insert Images
    const track = this.modal.querySelector('.ultra-rel__track');
    track.innerHTML = data.images.map(src => `<img src="${src}" class="ultra-rel__qv-img">`).join('');
    
    // Reset Scroll Position
    track.scrollLeft = 0;

    this.modal.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  closeModal() {
    this.modal.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ultra-rel__wrapper').forEach(el => new UltraRelated(el));
});
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('.ultra-rel__wrapper');
  if (el) new UltraRelated(el);
});